var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Button, } from "@chakra-ui/react";
/** This component is wrapper around Chakra-UI Modal component */
export const ConfirmModal = (props) => {
    const { title, content, onConfirm, onClose } = props, modalProps = __rest(props, ["title", "content", "onConfirm", "onClose"]);
    return (_jsxs(Modal, Object.assign({ onClose: onClose }, modalProps, { children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, { children: [_jsx(ModalHeader, { children: title }), _jsx(ModalCloseButton, {}), _jsx(ModalBody, { children: content }), _jsxs(ModalFooter, { children: [_jsx(Button, { colorScheme: "red", onClick: onConfirm, "data-cy": "confirm-btn", children: "Confirm" }), _jsx(Button, { ml: 3, onClick: onClose, "data-cy": "cancel-btn", children: "Cancel" })] })] })] })));
};
//# sourceMappingURL=confirmModal.js.map